import { render, staticRenderFns } from "./AssistantTeacherProcessNav.vue?vue&type=template&id=7535d5a2&scoped=true&"
import script from "./AssistantTeacherProcessNav.vue?vue&type=script&lang=js&"
export * from "./AssistantTeacherProcessNav.vue?vue&type=script&lang=js&"
import style0 from "./AssistantTeacherProcessNav.vue?vue&type=style&index=0&id=7535d5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7535d5a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
